module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 18\"><path d=\"M11.9 0H3.1L2 1.5V7h2V2.3L3.8 2H9v5h5v8.8l-.2.2H7.9l-1.8 2h8.4l1.4-1.4V4.2l-4-4.2zM11 5V2.3L13.8 5H11z\"/><path d=\"M6 13V9.6C6 8.8 5.2 8 4.4 8h-.8C2.8 8 2 8.8 2 9.6V13H0l4 4 4-4H6z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/download.svg
// module id = 37
// module chunks = 0